import * as React from "react";
import { BrowserRouter, Navigate, Routes, Route, useLocation, useNavigate, useHistory } from "react-router-dom";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useState } from 'react';
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import ProductList from "../components/ProductList"
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RawMaterialHome = () => {
  const { tabIndex } = useParams();


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const user = useSelector((state) => state.user);
    const [isAdmin, setIsAdmin] = useState(user?.role === 'Super Admin' ? true : false);
   
    const [selectedTab, setSelectedTab] = useState('1');
  
    const handleChange = (event, newValue) => {
      setSelectedTab(newValue);
    };

    const location = useLocation();
    let navigate = useNavigate();
    React.useEffect( () => {
      if(location.key === undefined || location.key === null || location.key === 'default'){
        navigate("/");   
      }
    }, [ location ] );

    React.useEffect( () => {
      if ( 1 == tabIndex || 2 == tabIndex ) {
        setSelectedTab( tabIndex);    
      }
  }, [ tabIndex ] );
   
  return (
   
    <TabContext value={selectedTab}>
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <TabList sx={{paddingLeft:"200px", paddingTop:"60px"}} TabIndicatorProps={{style: {backgroundColor: "#4863A0"}}}  onChange={handleChange}>
        <Tab label="Raw Materials" value="1" />
        {/* <Tab label="Data Center" value="2" /> */}
      </TabList>
    </Box>
    <TabPanel value="1"><ProductList/></TabPanel>
  </TabContext> 
  )
}

export default RawMaterialHome